import { useRoute, type RouteProp } from '@react-navigation/native';
import React from 'react';
import { DefaultScreenContainer } from '~/components';
import Iframe from '~/components/Iframe';
import type { RootStackParamList } from '~/navigation/types';

const contentStyle = {
  flexGrow: 1,
};

const IframeScreen = () => {
  const { params } =
    useRoute<RouteProp<RootStackParamList, 'MarisaServicos_Iframe'>>();

  return (
    <DefaultScreenContainer contentContainerStyle={contentStyle}>
      <Iframe url={params.url} />
    </DefaultScreenContainer>
  );
};

export default IframeScreen;
